"use strict";exports.capitalize=function(t){return t.charAt(0).toUpperCase()+t.slice(1)};
//# sourceMappingURL=capitalize-072b3373.js.map
